import styled from '@emotion/styled';
import Star from '@mui/icons-material/Star';
import React from 'react';

import {
  LeftNavMenu,
  LeftNavMenuItem,
  useLeftNavContext,
} from '~/client/components/base/left-nav';
import Spacer from '~/client/components/base/spacer';

interface Props {
  className?: string;
}

const PrimaryImpl: React.FC<Props> = ({ className }) => {
  const { jumpTo } = useLeftNavContext();
  const [selected, setSelected] = React.useState<string>();

  return (
    <LeftNavMenu
      className={className}
      name="primary"
      header={{ icon: 'brand', disabled: true }}
    >
      <LeftNavMenuItem
        icon={Star}
        selected={selected === 'dashboard'}
        onClick={() => setSelected('dashboard')}
      >
        Compliance
      </LeftNavMenuItem>
      <LeftNavMenuItem
        icon={Star}
        selected={selected === 'projects'}
        onClick={() => setSelected('projects')}
      >
        Projects with unnecessarily long name
      </LeftNavMenuItem>
      <Spacer className="grow" />
      <LeftNavMenuItem
        icon={Star}
        rightIcon="arrow-right"
        onClick={() => jumpTo('organization')}
      >
        Your Organization
      </LeftNavMenuItem>
      <LeftNavMenuItem
        icon={Star}
        rightIcon="arrow-right"
        onClick={() => jumpTo('account')}
      >
        Your Account
      </LeftNavMenuItem>
    </LeftNavMenu>
  );
};

const Primary = styled(PrimaryImpl)`
  .grow {
    flex-grow: 1;
  }
`;

export default Primary;
